import { zoomCanvas, zoomRuler  } from '@frontend/group/modules/canvas-zoom/utils';
import { resetCompCanvas, syncCompCanvas } from '@frontend/group/modules/comps';
import { ShowPageScopeCollector } from '@frontend/group/modules/scope-collectors/show-page-collector';
import {
  CANVAS_CONTAINER_ORIGINAL_WIDTH_KEY,
  CANVAS_CONTAINER_ORIGINAL_HEIGHT_KEY,
  INITIAL_ZOOM,
  ZOOM_IN_SCALE_FACTOR,
  ZOOM_OUT_SCALE_FACTOR,
  ZOOM_TYPE
} from '@frontend/group/modules/canvas-zoom/constants';

const getScopePage = () => ShowPageScopeCollector.get(['previews']);

export const handleTemplateZoom = (e, instanceId, zoomType) => {
  if (e) {
    e.stopPropagation();
    e.preventDefault();
  }

  const { previews } = getScopePage();
  const preview = previews.find(preview => preview.id === instanceId);

  if (!preview) {
    console.error('Preview was not found');
    return;
  }

  const scaleFactor = zoomType === ZOOM_TYPE.IN
    ? ZOOM_IN_SCALE_FACTOR
    : ZOOM_OUT_SCALE_FACTOR;

  const compWasExpanded = !!preview.canvas._compCanvasState;
  if (compWasExpanded) resetCompCanvas(preview);
  const $canvasContainer = $(preview.canvas.lowerCanvasEl).parents('.grid-stack-item').first().find('.canvas-container');
  const originalCanvasWidth = $canvasContainer.attr(CANVAS_CONTAINER_ORIGINAL_WIDTH_KEY);
  const originalCanvasHeight = $canvasContainer.attr(CANVAS_CONTAINER_ORIGINAL_HEIGHT_KEY);
  // Some canvases become significantly enlarged if they are not reset beforehand
  const needsReset = !originalCanvasWidth || !originalCanvasHeight;

  try {
    zoomCanvas(preview.canvas, scaleFactor);
    if (needsReset) {
      resetZoom(instanceId);
      zoomCanvas(preview.canvas, scaleFactor);
    }
  } finally {
    if (compWasExpanded) syncCompCanvas(preview);
  }

  const newWidth = preview.canvas.getWidth();
  const newHeight = preview.canvas.getHeight();
  zoomRuler(preview.ruler, newWidth, newHeight);
};

export const resetZoom = (instanceId) => {
  const preview = window.previews.find(preview => preview.id === instanceId);

  if (!preview) {
    console.error('Preview was not found');
    return;
  }

  const canvas = preview.canvas;
  const compWasExpanded = !!canvas._compCanvasState;
  if (compWasExpanded) resetCompCanvas(preview);

  const $canvasGridStackItem = $(canvas.lowerCanvasEl).parents('.grid-stack-item').first();
  const $canvasContainer = $canvasGridStackItem.find('.canvas-container');
  const $lowerCanvas = $canvasContainer.find('.lower-canvas');

  const originalCanvasWidth = $canvasContainer.attr(CANVAS_CONTAINER_ORIGINAL_WIDTH_KEY);
  const originalCanvasHeight = $canvasContainer.attr(CANVAS_CONTAINER_ORIGINAL_HEIGHT_KEY);

  if (!originalCanvasWidth || !originalCanvasHeight) {
    if (compWasExpanded) syncCompCanvas(preview);
    return;
  }

  const currentWidth = $lowerCanvas.width();
  const currentHeight = $lowerCanvas.height();

  const scaleX = originalCanvasWidth / currentWidth;
  const scaleY = originalCanvasHeight / currentHeight;

  const scaleRatio = (scaleX + scaleY) / 2;

  try {
    zoomCanvas(canvas, scaleRatio);
  } finally {
    if (compWasExpanded) syncCompCanvas(preview);
  }

  const newWidth = preview.canvas.getWidth();
  const newHeight = preview.canvas.getHeight();
  zoomRuler(preview.ruler, newWidth, newHeight);
};

export const initTemplateZoomListeners = (template, instance, onZoom) => {
  const instanceId = instance.instance_id;

  template.find('.zoom-in').on('click', (e) => {
    handleTemplateZoom(e, instanceId, ZOOM_TYPE.IN);
    onZoom?.();
  });
  template.find('.zoom-out').on('click', (e) => {
    handleTemplateZoom(e, instanceId, ZOOM_TYPE.OUT);
    onZoom?.();
  });
  template.find('.zoom-reset').on('click', () => {
    resetZoom(instanceId);
    onZoom?.();
  });
};
